export const AssessmentTabs = {
  Generate: 'Generate',
  History: 'History',
  Guide: 'Guide',
};
